import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as Actions from 'actions';

class LostPasswordForm extends React.Component {
		constructor(props) {
			super(props);

			this.state = {email : ''};

			this.handleSubmit = this.handleSubmit.bind(this)
		}

		componentWillMount() {
			this.props.userLoggedOut();
		}

		handleSubmit() {
			this.props.beginPasswordReset(this.state.email);
		}

    render() {

      return (
      	<section className='body-sign lost-password-container'>
          <div className='center-sign'>
            <a href='/' className='logo pull-left'>
              <img src='assets/images/logo-default.png' height='54' alt='Hailtrace App' />
            </a>
            <div className='panel panel-sign'>
              <div className='panel-title-sign mt-xl text-right'>
                <h2 className='title text-uppercase text-weight-bold m-none'><i className='fa fa-user mr-xs'></i> Sign In</h2>
              </div>
              <div className='panel-body'>
								<div className='form-group mb-lg'>
									<div className='row'>
										<div className='col-md-12'>
											<div className='input-group mb-md'>
												<input
													onChange={(e) => {this.setState({email : e.target.value})}}
													type='text'
													className='form-control'
													value={this.state.email}
													autoFocus
													placeholder='Enter Your Email Address'
													onKeyDown={(e) => {if(e.key === 'Enter') this.handleSubmit()}}
												/>
												<span className='input-group-btn'>
													<div
														onClick={this.handleSubmit}
														className='btn btn-primary'
														>
														Submit
													</div>
												</span>
											</div>
										</div>
									</div>
									<div className='alert alert-info'>
										Enter your email and we will send you instructions for resetting your password.
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
      );
    }
}

export default connect(null, Actions)(LostPasswordForm)



// WEBPACK FOOTER //
// ./src/browser/components/sales/lostPasswordForm.js